package com.wintermar.inspection.navigation.feature

import androidx.compose.foundation.layout.PaddingValues
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.lifecycle.viewmodel.navigation3.rememberViewModelStoreNavEntryDecorator
import androidx.navigation3.runtime.NavKey
import androidx.navigation3.runtime.entryProvider
import androidx.navigation3.runtime.rememberNavBackStack
import androidx.navigation3.runtime.rememberSaveableStateHolderNavEntryDecorator
import androidx.navigation3.ui.NavDisplay
import androidx.savedstate.serialization.SavedStateConfiguration
import com.wintermar.inspection.feature.presentation.template.landing.TemplateLandingScreen
import com.wintermar.inspection.navigation.Route
import kotlinx.serialization.modules.SerializersModule
import kotlinx.serialization.modules.polymorphic

@Composable
fun TemplateNavigation(
    paddingValues: PaddingValues,
    onVisibilityChanged: (Boolean) -> Unit,
    onStartInspection: (inspectionId: String) -> Unit
) {
    val templateBackStack = rememberNavBackStack(
        configuration = SavedStateConfiguration {
            serializersModule = SerializersModule {
                polymorphic(NavKey::class) {
                    subclass(Route.Template.List::class, Route.Template.List.serializer())
                }
            }
        },
        Route.Template.List
    )

    val currentChild = templateBackStack.lastOrNull() as? Route
    LaunchedEffect(currentChild) {
        onVisibilityChanged(currentChild?.showTopBar == true)
    }

    NavDisplay(
        backStack = templateBackStack,
        entryDecorators = listOf(
            rememberSaveableStateHolderNavEntryDecorator(),
            rememberViewModelStoreNavEntryDecorator()
        ),
        entryProvider = entryProvider {
            entry<Route.Template.List> {
                TemplateLandingScreen(
                    paddingValues = paddingValues,
                    onStartInspection = onStartInspection
                )
            }
        }
    )
}
